export default "/assets/images/mila-filter-video-2.mp4?f2ceac8d948f1c4e08d2ccbff2c2b390";